import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import { Redirect } from 'react-router';
import ShopForm from '../components/form/Shop';
import getShop from '../apollo/graphql/shop/get';
import getShops from '../apollo/graphql/shop/getShops';
import getCategories from '../apollo/graphql/category/getCategories';
import getLanguages from '../apollo/graphql/getLanguages';
import getPlaces from '../apollo/graphql/getPlaces';
import createShop from '../apollo/graphql/shop/create';
import deleteShop from '../apollo/graphql/shop/delete';
import updateShop from '../apollo/graphql/shop/update';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
  createTranslationsObjectOld,
} from '../helpers/translation';

class ShopContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
        block: '',
      },
      redirect: false,
      obj: {
        name: '',
        ttPhone: '',
        ttAllDays: 0,
        ttHours: null,
        type: '',
        place: null,
        is_new: null,
        is_heart: null,
        translations: createTranslationsObjectOld({
          title: '',
          content: '',
          ctaLabel: '',
          ctaUrl: '',
          importantTexte: '',
          importantCtaLabel: '',
          importantCtaUrl: '',
          ttTexte: '',
          ttCtaLabel: '',
          ttCtaUrl: '',
        }),
        blocks: [],
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getShop,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getShop.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getShop.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...convertGraphQlToObject(data.getShop),
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
              blocks: [...this.state.obj.blocks, ...newObject.blocks],
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    if (['restaurant', 'shop', 'bien-etre'].includes(event.target.id)) {
      //shop types
      newState.obj['type'] = event.target.id;
    } else if (typeof data === 'object' && data.id.indexOf('ttHours') !== -1) {
      const keys = data.id.match(/(\w+)/g);
      if (keys !== null && keys.length === 3) {
        if (newState.obj['ttHours']) {
          if (!newState.obj['ttHours'][keys[1]]) {
            newState.obj['ttHours'][keys[1]] = {};
          }
          newState.obj['ttHours'][keys[1]][keys[2]] = data.value;
        } else {
          newState.obj['ttHours'] = {};
        }
      }
    } else if (data === parseInt(data, 10)) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (type === 'dropdown') {
      //dropdown (place)
      if (data.id === 'block') {
        newState.status.block = data.value;
      } else {
        newState.obj[data.id] = data.value;
      }
    } else if (type === 'checkbox') {
      newState.obj[data.id] = data.checked;
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    window.scrollTo(0, 0);
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    let obj = convertObjetToGraphQlVariables(this.state.obj);
    if (obj.place) {
      obj.place_id = obj.place.id ? obj.place.id : obj.place;
      delete obj.place;
    }
    obj.blocks = [this.VideoGallery.getValues(), this.ImageGallery.getValues()];
    this.state.status.isNew
      ? this.props
          .createShop({
            variables: {
              ...obj,
            },
          })
          .then(({ data, errors }) => {
            if (errors) {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  errors: errors,
                },
              });
            } else {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  message: `Création effectuée le ${new Date(
                    Date.now(),
                  ).toLocaleString()}`,
                  isNew: false,
                },
                obj: data.createShop,
                redirect: true,
              });
            }
          })
      : this.props
          .updateShop({
            variables: {
              ...obj,
            },
          })
          .then(({ data, errors }) => {
            if (errors) {
              this.setState({
                status: {
                  ...this.state.status,
                  loading: false,
                  errors: errors,
                },
              });
            } else {
              this.setState({
                obj: data.updateShop,
                redirect: true,
              });
            }
          });
  }

  handleDelete(event, data) {
    event.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteShop({ variables: { id: this.state.obj.id } })
          .then(this.props.history.push('/shops'))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/shops" />;
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>;
    }

    return (
      <ShopForm
        obj={this.state.obj}
        status={this.state.status}
        languages={this.props.languages}
        places={this.props.places}
        categories={this.props.categories}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        imageGalleryRef={(ref) => (this.ImageGallery = ref)}
        videoGalleryRef={(ref) => (this.VideoGallery = ref)}
      />
    );
  }
}

const ShopContainerEnhanced = compose(
  graphql(getLanguages, { name: 'languages' }),
  graphql(getPlaces, { name: 'places' }),
  graphql(getCategories, { name: 'categories' }),
  graphql(updateShop, { name: 'updateShop' }),
  graphql(createShop, { name: 'createShop' }),
  graphql(deleteShop, {
    name: 'deleteShop',
    options: {
      update: (proxy, { data }) => {
        const shops = proxy.readQuery({ query: getShops });
        shops.getShops = shops.getShops.filter(
          (obj) => obj.id !== data.deleteShop.id,
        );
        proxy.writeQuery({ query: getShops, data: shops });
      },
    },
  }),
)(ShopContainer);

export default withApollo(ShopContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/ShopContainer.js